import { SDQuerySubscribersStore } from "../SDQuerySubscribersStore";
import { getPrevQueryID, getPrevQuery } from "../QueryGetters";
export function getQueryIDs(r) {
    const qID = r.query && SDQuerySubscribersStore.getQueryID(r.query);
    const qPrevID = getPrevQueryID(r);
    const qPrev = getPrevQuery(qPrevID);
    return {
        qID,
        qPrevID,
        qPrev
    };
}
//# sourceMappingURL=GetQueryIDs.js.map